import { useContext, useState } from "react";
import axios from "./axios";
import { UserContext } from "../components/context/UseContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useInfo = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setProfile } = useContext(UserContext);
  const getuserInfo = async (token, route, isArena) => {
    try {
      const res = await axios.get(
        `/audiences/get-profile?is_arena=${isArena}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setProfile(res?.data);
        toast.success("You're all set! Welcome aboard!");
        setLoading(false);
        const searchParams = new URLSearchParams(route);
        const data = searchParams.get("data");
        const storedSlug = localStorage.getItem("world_slug");
        localStorage.setItem("arena_hashed_d", encodeURIComponent(data));
        const urlDecoded = atob(decodeURIComponent(encodeURIComponent(data)));
        // 2. Base64 decode
        const decoded = urlDecoded;
        const decodedArr = decoded.split("|");
        if (decodedArr.length === 3) {
          const campaignId = decodedArr[0];
          const gameId = decodedArr[1];
          const userId = decodedArr[2];
          const expires = searchParams.get("expires");
          const signature = searchParams.get("signature");

          if (campaignId && expires && gameId && signature) {
            navigate(
              `/campaign_id/${campaignId}/game_id/${gameId}?userId=${userId}&expires=${expires}&signature=${signature}`
            );
          } else {
            navigate("/home");
          }
        } else {
          const brandId = decodedArr[0];
          const userId = decodedArr[1];
          const expires = searchParams.get("expires");
          const signature = searchParams.get("signature");

          if (brandId && expires && signature) {
            navigate(
              `/worlds/${storedSlug}?id=${brandId}&userId=${userId}&expires=${expires}&signature=${signature}`
            );
          } else {
            navigate("/home");
          }
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
    }
  };

  return { getuserInfo, loading, setLoading };
};
